import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
	template: '',
})
export class BaseHardwareScanModalComponent implements OnInit, OnDestroy {
	ngOnInit() {
		this.disableBackgroundNavigation(document);
	}

	ngOnDestroy() {
		this.reEnableBackgroundNavigation(document);
	}

	private disableBackgroundNavigation(document) {
		const modalNodes = Array.from(
			document.querySelectorAll('body .cdk-overlay-container mat-dialog-container *')
		);

		// by only finding elements that do not have tabindex="-1" we ensure we don't
		// corrupt the previous state of the element if a modal was already open
		const nonModalNodes = document.querySelectorAll('body vtr-root *:not([tabindex="-1"])');

		for (const node of nonModalNodes) {
			if (!modalNodes.includes(node)) {
				// save the previous tabindex state so we can restore it on close
				node.prevTabindex = node.getAttribute('tabindex');
				node.setAttribute('tabindex', -1);

				// tabindex=-1 does not prevent the mouse from focusing the node (which
				// would show a focus outline around the element). prevent this by disabling
				// outline styles while the modal is open
				// @see https://www.sitepoint.com/when-do-elements-take-the-focus/
				node.style.outline = 'none';
			}
		}
	}

	private reEnableBackgroundNavigation(document) {
		const nonModalNodes = Array.from<any>(document.querySelectorAll('body vtr-root *')).filter(
			(node) => 'prevTabindex' in node
		);

		// restore or remove tabindex from nodes
		for (const node of nonModalNodes) {
			node.setAttribute('tabindex', node.prevTabindex);
			delete node.prevTabindex;

			node.style.outline = null;
		}
	}
}
